module.exports = __webpack_public_path__ + "img/home-fitness1.a45443f4.jpg";